import { useState } from "react";
import { api, apiErr } from "../lib/api";

// Passwordless sign-in request. `variant` = "staff" (console styling) | "employee" (emp-theme classes).
export function MagicLinkForm({ email, setEmail, variant = "staff", testPrefix = "magic" }) {
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const emp = variant === "employee";
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try { await api.post("/auth/magic-link", { email }); setSent(true); } catch (e2) { setErr(apiErr(e2)); } finally { setBusy(false); }
  };
  if (sent) {
    return (
      <div data-testid={`${testPrefix}-sent`} className={emp ? "text-sm text-slate-600 bg-emerald-50 rounded-2xl px-4 py-4 leading-relaxed" : "text-sm border border-border bg-white p-4 leading-relaxed"}>
        <strong>Check your inbox.</strong> If <span className="font-mono">{email}</span> has an account, a one-time sign-in link is on its way. It expires in 15 minutes.
        <button type="button" data-testid={`${testPrefix}-again`} onClick={() => setSent(false)} className={`block mt-3 underline underline-offset-2 ${emp ? "text-blue-600" : "text-muted-foreground hover:text-black"}`}>Use a different email</button>
      </div>
    );
  }
  return (
    <form onSubmit={submit} data-testid={`${testPrefix}-form`} className={emp ? "" : "space-y-4"}>
      {emp ? (
        <label className="block mb-4"><span className="emp-label block mb-1.5 ml-1">Work email</span>
          <input data-testid={`${testPrefix}-email`} type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} className="emp-input" /></label>
      ) : (
        <div>
          <label className="text-xs font-mono uppercase tracking-widest text-muted-foreground">Email</label>
          <input data-testid={`${testPrefix}-email`} type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 w-full border border-input bg-white px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-black" />
        </div>
      )}
      {err && <p data-testid={`${testPrefix}-error`} className={emp ? "text-sm font-medium text-rose-600 bg-rose-50 rounded-2xl px-4 py-3 mb-4" : "text-sm text-destructive border border-destructive/30 bg-destructive/5 px-3 py-2"}>{err}</p>}
      <button data-testid={`${testPrefix}-submit`} disabled={busy} className={emp ? "emp-btn w-full" : "w-full bg-black text-white py-3 text-sm font-medium hover:bg-neutral-800 transition-colors disabled:opacity-50"}>
        {busy ? "Sending…" : "Email me a sign-in link"}
      </button>
      <p className={emp ? "text-xs text-slate-400 mt-3 text-center" : "text-[11px] text-muted-foreground"}>No password needed — we'll email a secure one-time link.</p>
    </form>
  );
}

export function AuthModeTabs({ mode, setMode, variant = "staff", testPrefix = "auth-mode" }) {
  const emp = variant === "employee";
  const btn = (m, label) => (
    <button type="button" key={m} data-testid={`${testPrefix}-${m}`} onClick={() => setMode(m)} aria-pressed={mode === m}
      className={emp
        ? `flex-1 py-2 text-sm font-semibold rounded-xl transition-colors ${mode === m ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-700"}`
        : `flex-1 py-2 text-xs font-mono uppercase tracking-widest transition-colors ${mode === m ? "bg-black text-white" : "text-muted-foreground hover:text-black"}`}>
      {label}
    </button>
  );
  return <div className={emp ? "flex bg-slate-100 rounded-2xl p-1 mb-6" : "flex border border-black mt-6"}>{btn("password", "Password")}{btn("magic", "Magic link")}</div>;
}
